import { render } from "./Mediate.vue?vue&type=template&id=a08e8600&scoped=true"
import script from "./Mediate.vue?vue&type=script&lang=js"
export * from "./Mediate.vue?vue&type=script&lang=js"

import "./Mediate.vue?vue&type=style&index=0&id=a08e8600&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08e8600"]])

export default __exports__